import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";


const TestimonialService = {
  AddTestimonial: async (testimonial_id, name, designation, feedback,image) => {
    try {
      const formData = new FormData();
      formData.append("testimonial_id", testimonial_id)
      formData.append("name", name)
      formData.append("designation", designation)
      formData.append("feedback", feedback)
      formData.append("image", image)
      const response = await axios.post(
        ApiConstants.addTestiMonial,
        formData,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getTestimonial: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.getTestimonial +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  updateTestimonialStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.changeStatusTestimonial,
        {
          id: id,
          is_active: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteTestimonial: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteTestimonial,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default TestimonialService;
